import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ErrorHandler,
  Injectable,
  ModuleWithProviders,
  NgModule,
  inject,
} from '@angular/core';
import { environment } from './environment';
import { GlobalErrorHandler } from './handlers/global-error.handler';

@Injectable()
export class EnvironmentHolder {
  public env = inject(environment);
}

@NgModule({
  imports: [],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    EnvironmentHolder,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class LoggingModule {
  public static forRoot(env): ModuleWithProviders<LoggingModule> {
    return {
      ngModule: LoggingModule,
      providers: [{ provide: environment, useValue: env }],
    };
  }
}
